export default __webpack_public_path__ + "static/media/centroMoons@3x.065dde83.webp";